module.exports = {
    base_url: "https://api.bridgeindonesia.id/api",
    fileDir: 'http://360admin.bridgeindonesia.id/web/upload/',    
    // base_url: "http://localhost/bridge-api/api",
    // fileDir: 'http://localhost/bridge-admin/web/upload/'
};
